import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import PublicBrand from "./PublicBrand";

const NAV_LINKS = [
  ["Product", "/product"],
  ["Connectors", "/connectors"],
  ["Use cases", "/use-cases"],
  ["Pricing", "/pricing"],
  ["Resources", "/resources"],
  ["Trust", "/trust"],
];

const LINK_CLASS = "inline-flex min-h-11 min-w-11 items-center rounded-sm transition hover:text-slate-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d48a28] focus-visible:ring-offset-2";

export default function PublicHeader({ overlay = false }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerClassName = `${overlay ? "absolute inset-x-0 top-0 z-40 " : ""}border-b border-slate-200 bg-white`;

  return (
    <header className={headerClassName}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-6 lg:px-8">
        <PublicBrand surface="light" />

        <nav data-testid="public-desktop-nav" aria-label="Public navigation" className="hidden items-center gap-6 text-sm font-medium text-slate-600 lg:flex">
          {NAV_LINKS.map(([label, to]) => (
            <Link key={to} to={to} className={LINK_CLASS}>{label}</Link>
          ))}
          <Link to="/login" className={`${LINK_CLASS} ml-2 font-semibold text-slate-700`}>Sign in</Link>
          <Link to="/register" className="ml-1 inline-flex min-h-11 min-w-11 items-center border border-[#d48a28] bg-[#d48a28] px-4 py-2.5 font-semibold text-[#0b1327] transition hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d48a28] focus-visible:ring-offset-2">Start a CRM scan</Link>
        </nav>

        <button
          type="button"
          onClick={() => setMobileOpen((open) => !open)}
          className="inline-flex h-11 w-11 items-center justify-center border border-slate-300 text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d48a28] focus-visible:ring-offset-2 lg:hidden"
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
        </button>
      </div>

      {mobileOpen && (
        <nav data-testid="public-mobile-nav" aria-label="Mobile public navigation" className="border-t border-slate-200 bg-white px-6 py-6 text-sm text-slate-700 lg:hidden">
          <div className="mx-auto grid max-w-7xl gap-4">
            {NAV_LINKS.map(([label, to]) => (
              <Link key={to} to={to} onClick={() => setMobileOpen(false)} className={`${LINK_CLASS} w-fit`}>{label}</Link>
            ))}
            <Link to="/login" onClick={() => setMobileOpen(false)} className={`${LINK_CLASS} w-fit font-semibold`}>Sign in</Link>
            <Link to="/register" onClick={() => setMobileOpen(false)} className="inline-flex min-h-11 min-w-11 w-fit items-center border border-[#d48a28] bg-[#d48a28] px-4 py-2.5 font-semibold text-[#0b1327] transition hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d48a28] focus-visible:ring-offset-2">Start a CRM scan</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
